



















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { eventStore, VendorEvent } from '../store/event-store'
import { orderStore } from '../store/order-store'
import { format } from 'date-fns'

interface UpcomingEvent {
  id: string;
  title: string;
  pickupStart: string;
}

@Component
export default class VendorAdminDashboardPage extends Vue {
  upcomingEvents: UpcomingEvent[] = [];

  get events () {
    return eventStore.events.slice(0, 3)
  }

  get orders () {
    return orderStore.orders.slice(0, 3)
  }

  @Watch('events', { immediate: true, deep: true })
  onEventsChanged (value: VendorEvent[]) {
    // console.log('onPropertyChanged', value, oldValue)
    this.upcomingEvents = value.map(ve => {
      return {
        id: ve.id || '',
        title: ve.title,
        pickupStart: ve.pickupStart ? format(ve.pickupStart.toDate(), 'MMM do, h a') : ''
      }
    })
  }
}
